<div class="container-fluid">
  <div class="row" style="margin: 0px">
    <div class="col-md-12" style="padding: 0px">
      <div class="card" style="margin-bottom: 0px">
        <div class="card-body">
          <form nz-form [formGroup]="modelsForm" class="login-form" (ngSubmit)="submitForm()" class="form-container">
            <div nz-row [nzGutter]="[24, 8]">
              <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8" formGroupName="model1" class="column-with-separator">
                <h4 style="margin-bottom: 2rem; font-size: 1.5rem;">Model 1</h4>
                <nz-form-item>
                  <nz-form-label [nzRequired]="!modelsForm.get('model1.job').value" nzFor="job1">
                    Job 1
                  </nz-form-label>
                  <nz-form-control nzErrorTip="You must select a job">
                    <nz-select nzShowSearch [nzLoading]="!!!project_jobs" style="width: 100%" placeholder="Select a job"
                      formControlName="job" id="job1">
                      @for (j of project_jobs; track j) {
                        <nz-option [nzLabel]="j.job_name" [nzValue]="j"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
                <div nz-row [nzGutter]="[8, 8]">
                  <nz-col nzXs="24" nzSm="6" nzMd="24" nzLg="24" nzXl="24" class="slider-label">Iteration</nz-col>
                  <div nz-col nzXs="24" nzSm="18" nzMd="24" nzLg="24" nzXl="24">
                    <app-slider style="padding: 0px;" label="Iteration" [showLabel]="false" [antd]="true" [min]="0" [max]="modelsForm.get('model1.job').value?.iterations || 1"
                      [step]="10" [value]="job1iteration" (valueChange)="onJob1IterationChange($event)">
                    </app-slider>
                  </div>
                </div>
                <div style="margin-top: 16px;"></div>
                <div  nz-row [nzGutter]="[8, 8]">
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label nzRequired nzFor="iteration1">
                        Color Map
                      </nz-form-label>
                      <nz-form-control nzErrorTip="You must select a color map">
                        <nz-select nzShowSearch style="width: 100%" formControlName="color_map"
                          [nzDisabled]="!modelsForm.get('model1.job').value">
                          @for (mt of palettes; track mt) {
                            <nz-option
                            [nzLabel]="mt" [nzValue]="mt"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label nzRequired nzFor="model_type1">
                        Model type
                      </nz-form-label>
                      <nz-form-control nzErrorTip="You must select a model type">
                        <nz-select nzShowSearch style="width: 100%" formControlName="model_type"
                          [nzDisabled]="!modelsForm.get('model1.job').value">
                          @for (mt of modelTypes1; track mt) {
                            <nz-option [nzLabel]="mt.name" [nzValue]="mt.id"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
                <div style="margin-top: 16px;"></div>
                <div nz-row [nzGutter]="[8, 8]">
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label>Min</nz-form-label>
                      <nz-form-control>
                        <nz-input-number style="width: 100%" formControlName="min"
                        [nzDisabled]="!modelsForm.get('model1.job').value"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label>Max</nz-form-label>
                      <nz-form-control>
                        <nz-input-number style="width: 100%" formControlName="max"
                        [nzDisabled]="!modelsForm.get('model1.job').value"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
              <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8" formGroupName="model2" class="column-with-separator">
                <h4 style="margin-bottom: 2rem; font-size: 1.5rem;">Model 2</h4>
                <nz-form-item>
                  <nz-form-label [nzRequired]="!modelsForm.get('model2.job').value" nzFor="job2" >
                    Job 2
                  </nz-form-label>
                  <nz-form-control nzErrorTip="You must select a job">
                    <nz-select nzShowSearch [nzLoading]="!!!project_jobs" style="width: 100%" placeholder="Select a job"
                      formControlName="job" id="job2">
                      @for (j of project_jobs; track j) {
                        <nz-option [nzLabel]="j.job_name" [nzValue]="j"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
                <div nz-row [nzGutter]="[8, 8]">
                  <nz-col nzXs="24" nzSm="6" nzMd="24" nzLg="24" nzXl="24" class="slider-label">Iteration</nz-col>
                  <div nz-col nzXs="24" nzSm="18" nzMd="24" nzLg="24" nzXl="24">
                    <app-slider style="padding: 0px;" label="Iteration" [showLabel]="false" [antd]="true" [min]="0" [max]="modelsForm.get('model2.job').value?.iterations || 1"
                      [step]="10" [value]="job2iteration" (valueChange)="onJob2IterationChange($event)">
                    </app-slider>
                  </div>
                </div>
                <div style="margin-top: 16px;"></div>
                <div  nz-row [nzGutter]="[8, 8]">
                  <div nz-col nzSpan="12" >
                    <nz-form-item>
                      <nz-form-label nzRequired nzFor="color_map2">
                        Color Map
                      </nz-form-label>
                      <nz-form-control nzErrorTip="You must select a color map">
                        <nz-select nzShowSearch style="width: 100%" formControlName="color_map"
                          [nzDisabled]="!modelsForm.get('model2.job').value">
                          @for (mt of palettes; track mt) {
                            <nz-option
                            [nzLabel]="mt" [nzValue]="mt"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label nzRequired nzFor="model_type2">
                        Model type
                      </nz-form-label>
                      <nz-form-control nzErrorTip="You must select a model type">
                        <nz-select nzShowSearch style="width: 100%" formControlName="model_type"
                          [nzDisabled]="!modelsForm.get('model2.job').value">
                          @for (mt of modelTypes2; track mt) {
                            <nz-option [nzLabel]="mt.name" [nzValue]="mt.id"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
                <div style="margin-top: 16px;"></div>
                <div nz-row [nzGutter]="[8, 8]">
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label>Min</nz-form-label>
                      <nz-form-control>
                        <nz-input-number style="width: 100%" formControlName="min"
                        [nzDisabled]="!modelsForm.get('model2.job').value"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label>Max</nz-form-label>
                      <nz-form-control>
                        <nz-input-number style="width: 100%" formControlName="max"
                        [nzDisabled]="!modelsForm.get('model2.job').value"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
              <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
                <div class="comparison-header" style="margin-bottom: 2rem;">
                  <h6 style="font-size: 1.5rem; margin-bottom: 0px; margin-top: 0px;">Comparison Settings</h6>
                </div>
                <div nz-row [nzGutter]="[8, 8]" style="margin-bottom: 16px; margin-top: 16px;">
                  @if (!is2DJob()) {
                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                      <nz-form-item>
                        <nz-form-label>Dimension</nz-form-label>
                        <nz-form-control>
                          <nz-select formControlName="dimension">
                            <nz-option nzLabel="Inline" nzValue="Inline"></nz-option>
                            <nz-option nzLabel="Crossline" nzValue="Crossline"></nz-option>
                            <nz-option nzLabel="Depth" nzValue="Depth"></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  }
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label>Interleaved Extent</nz-form-label>
                      <nz-form-control>
                        <nz-input-number style="width: 100%" formControlName="interleavedExtent" [nzMin]="0"
                        ></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>


                </div>

                @if (!is2DJob()) {
                  <div nz-row [nzGutter]="[8, 8]">
                    <nz-col nzXs="24" nzSm="6" nzMd="24" nzLg="24" nzXl="24" class="slider-label">Slice Number</nz-col>
                    <div nz-col nzXs="24" nzSm="18" nzMd="24" nzLg="24" nzXl="24">
                      <app-slider style="padding: 0px;" [showLabel]="false" label="Slice" [antd]="true" [min]="1" [max]="maxSliceNumber"
                        [step]="1" [value]="sliceNumber" (valueChange)="onSliceNumberChange($event)">
                      </app-slider>
                    </div>
                  </div>
                }
                <div style="margin-top: 12px;"></div>


                <div nz-row [nzGutter]="[8, 8]">
                  <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                      <nz-form-label>Difference Palette</nz-form-label>
                      <nz-form-control>
                        <nz-select formControlName="differencePalette">
                          @for (mt of palettes; track mt) {
                            <nz-option
                            [nzLabel]="mt" [nzValue]="mt"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="is2DJob() ? 24 : 12" [nzLg]="is2DJob() ? 24 : 12"
                    [nzXl]="is2DJob() ? 24 : 12">
                    <nz-form-item>
                      <nz-form-label>Difference Min/Max</nz-form-label>
                      <nz-form-control>
                        <nz-input-number style="width: 100%" formControlName="differenceRange"
                        nzPlaceHolder="Enter max value (min will be -max)"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>


                <div class="plot-button-container" style="text-align: center; display: flex; gap: 12px; justify-content: center;">
                  @if (!isLoadingComparison) {
                    <button nz-button nzType="primary"
                      [disabled]="!this.modelsForm.valid" nzSize="large"
                      >
                      Plot Comparison
                    </button>
                  }
                  @if (isLoadingComparison) {
                    <button nz-button nzType="primary"
                      nzSize="large" [nzLoading]="true" [disabled]="true"
                      >
                      Generating...
                    </button>
                  }
                  @if (hasComparisonResults && !isLoadingComparison) {
                    <button
                      type="button"
                      nz-button nzType="default" nzSize="large"
                      (click)="takeScreenshot()"
                      nz-tooltip="Take a screenshot of the current tab"
                      >
                      <i nz-icon nzType="camera" nzTheme="outline"></i>
                      Screenshot
                    </button>
                  }
                </div>

              </div>
            </div>
          </form>

          <nz-tabs #tabset [nzAnimated]="false" style="margin-top: 0rem;" (keydown.arrowLeft)="selectPreviousTab()"
            (keydown.arrowRight)="selectNextTab()"
            tabindex="0">
            <nz-tab nzTitle="{{ modelsForm.get('model1.job').value?.job_name ? (modelsForm.get('model1.job').value.job_name.length > 6 ? modelsForm.get('model1.job').value.job_name.substring(0, 6) + '...' : modelsForm.get('model1.job').value.job_name) : 'Job 1' }}">
              <ng-container [ngTemplateOutlet]="graphTemplate" [ngTemplateOutletContext]="{ tab: 'job1' }"></ng-container>
            </nz-tab>
            <nz-tab nzTitle="{{ modelsForm.get('model2.job').value?.job_name ? (modelsForm.get('model2.job').value.job_name.length > 6 ? modelsForm.get('model2.job').value.job_name.substring(0, 6) + '...' : modelsForm.get('model2.job').value.job_name) : 'Job 2' }}">
              <ng-container [ngTemplateOutlet]="graphTemplate" [ngTemplateOutletContext]="{ tab: 'job2' }"></ng-container>
            </nz-tab>
            <nz-tab nzTitle="Difference">
              <ng-container [ngTemplateOutlet]="graphTemplate" [ngTemplateOutletContext]="{ tab: 'difference' }"></ng-container>
            </nz-tab>
            <nz-tab nzTitle="Interleaved">
              <ng-container [ngTemplateOutlet]="graphTemplate"
              [ngTemplateOutletContext]="{ tab: 'interleaved' }"></ng-container>
            </nz-tab>
          </nz-tabs>

          <ng-template #graphTemplate let-tab="tab">
            <div class="chart-tab-container">
              <div class="chart-content">
                <div class="chart-display">
                  <!-- Show loading indicator when request is in progress -->
                  @if (isLoadingComparison) {
                    <div class="chart-loading-state"
                      style="display: flex; align-items: center; justify-content: center; height: 100%; min-height: 400px;">
                      <nz-spin nzSize="large">
                        <div style="padding: 20px; text-align: center;">
                          <span style="font-size: 16px; color: #666;">Loading {{ getTabDisplayName(tab) }}...</span>
                        </div>
                      </nz-spin>
                    </div>
                  }

                  <!-- Show empty state when no data and not loading -->
                  @if (!isLoadingComparison && !hasComparisonResults) {
                    <div class="chart-empty-state"
                      style="display: flex; align-items: center; justify-content: center; height: 100%; min-height: 400px;">
                      <nz-empty
                        nzNotFoundContent="Configure your settings above and click 'Plot Comparison' to generate visualization"
                        [nzNotFoundImage]="'simple'">
                        <div nz-empty-footer>
                          <p style="color: #8c8c8c; font-size: 14px; margin-top: 16px;">
                            <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
                            Changes to jobs, iterations, dimensions, or other settings will clear the current plot
                          </p>
                        </div>
                      </nz-empty>
                    </div>
                  }

                  <!-- Show actual chart when data is available -->
                  @if (!isLoadingComparison && hasComparisonResults) {
                    <div>
                      <app-model-visualizer-chart
                        [chartType]="tab"
                        [is2d]="is2DJob()"
                        [comparisonData]="comparisonResults">
                      </app-model-visualizer-chart>
                    </div>
                  }
                </div>
              </div>
            </div>
          </ng-template>

          <!-- <div #chartContainer class="d3-chart-container" style="display: none;">
          <div #chart class="d3-chart"></div>
        </div> -->
      </div>
    </div>
  </div>
</div>
</div>